export var ThemeEngine;
(function (ThemeEngine) {
    ThemeEngine["cssFilter"] = "cssFilter";
    ThemeEngine["svgFilter"] = "svgFilter";
    ThemeEngine["staticTheme"] = "staticTheme";
    ThemeEngine["dynamicTheme"] = "dynamicTheme";
})(ThemeEngine || (ThemeEngine = {}));
